(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.BC_CART_DRAWER_READY) return;
    window.BC_CART_DRAWER_READY = true;

    var activeDrawer = null;
    var lastFocused = null;

    function selectors(root, selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents, drawer, cart) {
      var amount = (Number(cents || 0) / 100);
      var currency = (cart && cart.currency) || (drawer && drawer.dataset.currency) || 'EUR';

      if (currency === 'EUR') {
        return '€' + amount.toFixed(2).replace('.', ',');
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency,
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    }

    function icon(name) {
      var paths = {
        close: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
        truck: '<path d="M10 17h4V5H2v12h3"/><path d="M14 17h1"/><path d="M19 17h3v-6h-4l-4-4v10h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>',
        lock: '<rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
        return: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 1 1 0 12h-2"/>',
        chat: '<path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>',
        paw: '<circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><circle cx="4" cy="16" r="2"/><path d="M9 10c1.2-2 4.8-2 6 0l3 5.5c1.1 2-.3 4.5-2.6 4.5H8.6c-2.3 0-3.7-2.5-2.6-4.5z"/>',
        arrow: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
      };

      return '<svg aria-hidden="true" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + (paths[name] || paths.paw) + '</svg>';
    }

    function itemSubtitle(item) {
      if (!item || !item.options_with_values) return '';
      return item.options_with_values
        .map(function (option) { return option && option.value; })
        .filter(function (value) { return value && value !== 'Default Title'; })
        .join(' · ');
    }

    function imageUrl(item) {
      if (item && item.featured_image && item.featured_image.url) return item.featured_image.url;
      if (item && item.image) return item.image;
      return '';
    }

    var variantCompareAtCache = {};

    function propertyCompareAtPrice(item) {
      if (!item || !item.properties) return 0;
      return Number(item.properties._bc_compare_at_price || item.properties._bc_compare_at_cents || 0);
    }

    function cacheProductCompareAt(product) {
      if (!product || !product.variants || !product.variants.length) return;

      product.variants.forEach(function (variant) {
        if (!variant || !variant.id) return;
        variantCompareAtCache[String(variant.id)] = Number(variant.compare_at_price || 0);
      });
    }

    function attachCompareAtPrices(cart) {
      if (!cart || !Array.isArray(cart.items)) return cart;

      cart.items.forEach(function (item) {
        var variantId = String(item.variant_id || item.id || '');
        item._bc_compare_at_price = propertyCompareAtPrice(item) || Number(variantCompareAtCache[variantId] || 0);
      });

      return cart;
    }

    function enrichCartComparePrices(cart) {
      attachCompareAtPrices(cart);

      if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);

      var handles = [];
      cart.items.forEach(function (item) {
        if (!item || item._bc_compare_at_price || !item.handle) return;
        if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
      });

      if (!handles.length) return Promise.resolve(cart);

      return Promise.all(handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .then(cacheProductCompareAt)
          .catch(function () {
            return null;
          });
      })).then(function () {
        return attachCompareAtPrices(cart);
      });
    }

    function linePriceMarkup(item, drawer, cart) {
      var finalLinePrice = Number(item.final_line_price || item.line_price || 0);
      var compareAtPrice = Number(item._bc_compare_at_price || 0);
      var compareAtLinePrice = compareAtPrice * Number(item.quantity || 1);
      var savings = Math.max(0, compareAtLinePrice - finalLinePrice);

      return [
        '<div class="bc-cart-drawer__line-price">',
          savings > 0 ? '<s>' + formatMoney(compareAtLinePrice, drawer, cart) + '</s>' : '',
          '<strong>' + formatMoney(finalLinePrice, drawer, cart) + '</strong>',
          savings > 0 ? '<span>Save ' + formatMoney(savings, drawer, cart) + '</span>' : '',
        '</div>',
      ].join('');
    }

    function itemMarkup(item, drawer, cart) {
      var subtitle = itemSubtitle(item);
      var image = imageUrl(item);
      var title = escapeHtml(item.product_title || item.title || 'Cart item');
      var url = item.url || '#';

      return [
        '<article class="bc-cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">',
          '<a class="bc-cart-drawer__item-media" href="' + escapeHtml(url) + '">',
            image ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : '<span>' + icon('paw') + '</span>',
          '</a>',
          '<div class="bc-cart-drawer__item-main">',
            '<div class="bc-cart-drawer__item-copy">',
              '<a href="' + escapeHtml(url) + '">' + title + '</a>',
              subtitle ? '<p>' + escapeHtml(subtitle) + '</p>' : '',
            '</div>',
            '<div class="bc-cart-drawer__qty" aria-label="Quantity for ' + title + '">',
              '<button type="button" data-bc-cart-qty-minus aria-label="Decrease quantity">-</button>',
              '<span data-bc-cart-qty>' + Number(item.quantity || 0) + '</span>',
              '<button type="button" data-bc-cart-qty-plus aria-label="Increase quantity">+</button>',
            '</div>',
          '</div>',
          '<div class="bc-cart-drawer__item-side">',
            '<button class="bc-cart-drawer__remove" type="button" data-bc-cart-remove aria-label="Remove ' + title + '">' + icon('close') + '</button>',
            linePriceMarkup(item, drawer, cart),
          '</div>',
        '</article>',
      ].join('');
    }

    function upsellMarkup(drawer, cart) {
      var template = drawer.querySelector('[data-bc-cart-upsell-template]') || document.querySelector('[data-bc-cart-upsell-template]');
      if (!template || !template.innerHTML) return '';
      var variantId = Number(drawer.dataset.upsellVariantId || 0);
      if (variantId && cart && cart.items && cart.items.some(function (item) { return Number(item.variant_id) === variantId; })) return '';
      var key = 'bc-cart-upsell-dismissed-' + (drawer.dataset.upsellVariantId || 'default');
      if (window.sessionStorage && sessionStorage.getItem(key) === '1') return '';
      return template.innerHTML;
    }

    function emptyMarkup(drawer) {
      return [
        '<div class="bc-cart-drawer__empty">',
          '<div class="bc-cart-drawer__empty-icon">' + icon('paw') + '</div>',
          '<h3>' + escapeHtml(drawer.dataset.emptyHeading || 'Your cart is empty') + '</h3>',
          '<p>' + escapeHtml(drawer.dataset.emptyMessage || 'Browse Bluey-approved pet essentials and add your favorites.') + '</p>',
          '<a class="bc-cart-drawer__empty-cta" href="' + escapeHtml(drawer.dataset.emptyLink || '/collections/all') + '">',
            escapeHtml(drawer.dataset.emptyCta || 'Browse the shop') + icon('arrow'),
          '</a>',
        '</div>',
      ].join('');
    }

    function filledMarkup(drawer, cart) {
      return [
        '<div class="bc-cart-drawer__items" data-bc-cart-items>',
          cart.items.map(function (item) { return itemMarkup(item, drawer, cart); }).join(''),
        '</div>',
        '<div class="bc-cart-drawer__shipping">',
          '<span>' + icon('truck') + escapeHtml(drawer.dataset.shippingMessage || 'Free delivery on this order') + '</span>',
          '<strong>' + escapeHtml(drawer.dataset.shippingPrice || '€0,00') + '</strong>',
        '</div>',
        upsellMarkup(drawer, cart),
      ].join('');
    }

    function setFooter(drawer, cart) {
      var footer = drawer.querySelector('[data-bc-cart-footer]');
      if (!footer) return;
      footer.hidden = !cart || !cart.item_count;
      if (!cart || !cart.item_count) return;

      var subtotal = footer.querySelector('[data-bc-cart-subtotal]');
      var total = footer.querySelector('[data-bc-cart-total]');
      if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price, drawer, cart);
      if (total) total.textContent = formatMoney(cart.total_price, drawer, cart);
    }

    function updateCountLabel(drawer, cart) {
      var label = drawer.querySelector('[data-bc-cart-count-label]');
      if (!label) return;
      var count = Number(cart && cart.item_count ? cart.item_count : 0);
      label.textContent = count === 1 ? '1 item' : count + ' items';
    }

    function renderCart(drawer, cart) {
      var body = drawer.querySelector('[data-bc-cart-body]');
      if (!body || !cart) return;
      updateCountLabel(drawer, cart);
      body.innerHTML = cart.item_count ? filledMarkup(drawer, cart) : emptyMarkup(drawer);
      setFooter(drawer, cart);
      drawer.dataset.cartItemCount = cart.item_count;
    }

    function setLoading(drawer, isLoading) {
      var loading = drawer.querySelector('[data-bc-cart-state="loading"]');
      if (loading) loading.hidden = !isLoading;
      drawer.classList.toggle('is-busy', !!isLoading);
    }

    function thirdPartyWidgets() {
      return selectors(document, '#ShopifyChat, inbox-online-store-chat#ShopifyChat, .bacurr-cur-block, .bacurr-dropdownChoices');
    }

    function setThirdPartyWidgetsHidden(hidden) {
      thirdPartyWidgets().forEach(function (widget) {
        if (hidden) {
          if (!widget.dataset.bcCartWidgetHidden) {
            widget.dataset.bcCartWidgetHidden = 'true';
            widget.dataset.bcCartPreviousOpacity = widget.style.opacity || '';
            widget.dataset.bcCartPreviousVisibility = widget.style.visibility || '';
            widget.dataset.bcCartPreviousPointerEvents = widget.style.pointerEvents || '';
          }
          widget.style.setProperty('opacity', '0', 'important');
          widget.style.setProperty('visibility', 'hidden', 'important');
          widget.style.setProperty('pointer-events', 'none', 'important');
          return;
        }

        if (!widget.dataset.bcCartWidgetHidden) return;
        if (widget.dataset.bcCartPreviousOpacity) {
          widget.style.opacity = widget.dataset.bcCartPreviousOpacity;
        } else {
          widget.style.removeProperty('opacity');
        }
        if (widget.dataset.bcCartPreviousVisibility) {
          widget.style.visibility = widget.dataset.bcCartPreviousVisibility;
        } else {
          widget.style.removeProperty('visibility');
        }
        if (widget.dataset.bcCartPreviousPointerEvents) {
          widget.style.pointerEvents = widget.dataset.bcCartPreviousPointerEvents;
        } else {
          widget.style.removeProperty('pointer-events');
        }
        delete widget.dataset.bcCartWidgetHidden;
        delete widget.dataset.bcCartPreviousOpacity;
        delete widget.dataset.bcCartPreviousVisibility;
        delete widget.dataset.bcCartPreviousPointerEvents;
      });
    }

    function setError(drawer, hasError) {
      var error = drawer.querySelector('[data-bc-cart-state="error"]');
      if (error) error.hidden = !hasError;
    }

    function fetchCart(drawer) {
      setError(drawer, false);
      setLoading(drawer, true);
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed');
          return response.json();
        })
        .then(enrichCartComparePrices)
        .then(function (cart) {
          renderCart(drawer, cart);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'bc-cart-drawer', data: { itemCount: cart.item_count, source: 'bc-cart-drawer' } },
          }));
          return cart;
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function changeQuantity(drawer, key, quantity) {
      setLoading(drawer, true);
      setError(drawer, false);
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then(enrichCartComparePrices)
        .then(function (cart) {
          renderCart(drawer, cart);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'bc-cart-drawer', data: { itemCount: cart.item_count, source: 'bc-cart-drawer' } },
          }));
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function addUpsell(drawer, variantId) {
      if (!variantId) return;
      setLoading(drawer, true);
      setError(drawer, false);
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Upsell add failed');
          return fetchCart(drawer);
        })
        .catch(function () {
          setError(drawer, true);
        })
        .finally(function () {
          setLoading(drawer, false);
        });
    }

    function openDrawer(drawer, cart) {
      if (!drawer) return;
      activeDrawer = drawer;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      document.body.classList.add('bc-cart-drawer-open');
      setThirdPartyWidgetsHidden(true);
      drawer.querySelector('.bc-cart-drawer__panel').focus({ preventScroll: true });
      if (cart) {
        renderCart(drawer, cart);
      } else {
        fetchCart(drawer);
      }
    }

    function closeDrawer(drawer) {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('bc-cart-drawer-open');
      setThirdPartyWidgetsHidden(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
      activeDrawer = null;
    }

    function getDrawer() {
      return document.querySelector('[data-bc-cart-drawer]');
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-bc-cart-open]');
      if (opener) {
        var drawer = getDrawer();
        if (drawer) {
          event.preventDefault();
          openDrawer(drawer);
        }
        return;
      }

      var close = event.target.closest('[data-bc-cart-close]');
      if (close) {
        closeDrawer(close.closest('[data-bc-cart-drawer]'));
        return;
      }

      var retry = event.target.closest('[data-bc-cart-retry]');
      if (retry) {
        fetchCart(retry.closest('[data-bc-cart-drawer]'));
        return;
      }

      var qtyButton = event.target.closest('[data-bc-cart-qty-minus], [data-bc-cart-qty-plus], [data-bc-cart-remove]');
      if (qtyButton) {
        var drawer = qtyButton.closest('[data-bc-cart-drawer]');
        var item = qtyButton.closest('[data-line-key]');
        if (!drawer || !item) return;
        var current = Number((item.querySelector('[data-bc-cart-qty]') || {}).textContent || 0);
        var next = current;
        if (qtyButton.matches('[data-bc-cart-remove]')) next = 0;
        if (qtyButton.matches('[data-bc-cart-qty-minus]')) next = current - 1;
        if (qtyButton.matches('[data-bc-cart-qty-plus]')) next = current + 1;
        changeQuantity(drawer, item.dataset.lineKey, next);
        return;
      }

      var upsellAdd = event.target.closest('[data-bc-cart-upsell-add]');
      if (upsellAdd) {
        addUpsell(upsellAdd.closest('[data-bc-cart-drawer]'), upsellAdd.dataset.variantId);
        return;
      }

      var upsellDismiss = event.target.closest('[data-bc-cart-upsell-dismiss]');
      if (upsellDismiss) {
        var upsell = upsellDismiss.closest('[data-bc-cart-upsell]');
        var drawer = upsellDismiss.closest('[data-bc-cart-drawer]');
        var key = 'bc-cart-upsell-dismissed-' + ((drawer && drawer.dataset.upsellVariantId) || 'default');
        if (window.sessionStorage) sessionStorage.setItem(key, '1');
        if (upsell) upsell.hidden = true;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeDrawer) {
        closeDrawer(activeDrawer);
      }
    });

    document.addEventListener('bc-cart:open', function (event) {
      openDrawer(getDrawer(), event.detail && event.detail.cart);
    });

    document.addEventListener('bc-cart:refresh', function (event) {
      var drawer = getDrawer();
      if (!drawer) return;
      if (event.detail && event.detail.cart) {
        renderCart(drawer, event.detail.cart);
      } else {
        fetchCart(drawer);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-bc-collection-sort]')) return;
    if (event.target.form) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCFAQAccordion) {
    window.BCFAQAccordion = true;

    document.addEventListener('click', function(event) {
      var button = event.target.closest('.bc-faq__button');
      if (!button) return;

      var item = button.closest('.bc-faq__item');
      var panelId = button.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!item || !panel) return;

      var willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      item.classList.toggle('is-open', willOpen);

      if (willOpen) {
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-recs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.BCProductRecommendationsInit) return;
    window.BCProductRecommendationsInit = true;

    function closestTrack(target) {
      return target instanceof Element ? target.closest('[data-bc-rec-track]') : null;
    }

    function getScrollAmount(track) {
      var slide = track.querySelector('.bc-recommendations__slide');
      var gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
      if (!slide) return track.clientWidth * 0.8;
      return slide.getBoundingClientRect().width + gap;
    }

    document.addEventListener('click', function (event) {
      var previous = event.target instanceof Element ? event.target.closest('[data-bc-rec-prev]') : null;
      var next = event.target instanceof Element ? event.target.closest('[data-bc-rec-next]') : null;
      if (!previous && !next) return;

      var section = (previous || next).closest('.bc-recommendations');
      var track = section ? section.querySelector('[data-bc-rec-track]') : null;
      if (!track) return;

      var direction = next ? 1 : -1;
      track.scrollBy({ left: getScrollAmount(track) * direction, behavior: 'smooth' });
    });

    var dragState = null;

    document.addEventListener('pointerdown', function (event) {
      var track = closestTrack(event.target);
      if (!track || event.button !== 0) return;

      dragState = {
        track: track,
        pointerId: event.pointerId,
        startX: event.clientX,
        scrollLeft: track.scrollLeft,
        moved: false,
      };
      track.classList.add('is-dragging');
      if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
    });

    document.addEventListener('pointermove', function (event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      var delta = event.clientX - dragState.startX;
      if (Math.abs(delta) > 4) dragState.moved = true;
      if (dragState.moved) event.preventDefault();
      dragState.track.scrollLeft = dragState.scrollLeft - delta;
    });

    function endDrag(event) {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      var track = dragState.track;
      var moved = dragState.moved;
      track.classList.remove('is-dragging');
      if (track.releasePointerCapture) {
        try {
          track.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* pointer capture may already be released */
        }
      }
      dragState = null;

      if (moved) {
        track.setAttribute('data-bc-rec-dragged', 'true');
        window.setTimeout(function () {
          track.removeAttribute('data-bc-rec-dragged');
        }, 0);
      }
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);

    document.addEventListener('click', function (event) {
      var track = closestTrack(event.target);
      if (!track || track.getAttribute('data-bc-rec-dragged') !== 'true') return;
      var link = event.target instanceof Element ? event.target.closest('a') : null;
      if (link) event.preventDefault();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-product-universal"] && !Shopify.designMode) return;
  try {
    
  if (!window.BCProductUniversalInit) {
    window.BCProductUniversalInit = true;

    function formatMoney(cents, currency) {
      var value = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'EUR' }).format(value);
      } catch (e) {
        return 'EUR ' + value.toFixed(2);
      }
    }

    function formatSaleBadge(prefix, cents, compareCents) {
      if (!(compareCents > cents) || compareCents <= 0) return '';
      var percent = Math.round(((compareCents - cents) * 100) / compareCents);
      if (!Number.isFinite(percent) || percent <= 0) return '';
      return String(prefix || 'Save') + ' ' + String(percent) + '%';
    }

    function setGallery(section, index) {
      var panels = section.querySelectorAll('[data-bc-gallery-panel]');
      var thumbs = section.querySelectorAll('[data-bc-gallery-thumb]');
      var counter = section.querySelector('[data-bc-gallery-count]');
      if (!panels.length) return;
      var next = (index + panels.length) % panels.length;
      panels.forEach(function(panel, i) {
        panel.toggleAttribute('hidden', i !== next);
        panel.classList.toggle('is-active', i === next);
      });
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('is-active', i === next);
      });
      if (counter) counter.textContent = String(next + 1) + ' / ' + String(panels.length);
      section.setAttribute('data-active-gallery', String(next));
    }

    function findGroupedVariant(section, groupKey, plug) {
      var fallback = null;
      var exact = null;
      section.querySelectorAll('[data-bc-variant-button]').forEach(function(button) {
        if (button.getAttribute('data-variant-group-key') !== groupKey) return;
        if (!fallback) fallback = button;
        if (plug && button.getAttribute('data-variant-plug') === plug) exact = button;
      });
      return exact || fallback;
    }

    function syncGroupedPicker(section, variantButton) {
      var groupKey = variantButton.getAttribute('data-variant-group-key') || '';
      var plug = variantButton.getAttribute('data-variant-plug') || '';
      var plugSelector = section.querySelector('[data-bc-plug-selector]');
      var selectedGroup = null;

      section.setAttribute('data-selected-group', groupKey);
      section.setAttribute('data-selected-plug', plug);

      section.querySelectorAll('[data-bc-group-button]').forEach(function(button) {
        var selected = button.getAttribute('data-group-key') === groupKey;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        if (selected) selectedGroup = button;
      });

      var shouldShowPlug = selectedGroup && selectedGroup.getAttribute('data-group-has-plug') === 'true';
      if (plugSelector) {
        plugSelector.toggleAttribute('hidden', !shouldShowPlug);
      }

      section.querySelectorAll('[data-bc-plug-button]').forEach(function(button) {
        var selected = shouldShowPlug && button.getAttribute('data-plug') === plug;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function updateVariant(section, button) {
      var id = button.getAttribute('data-variant-id');
      var title = button.getAttribute('data-variant-title') || '';
      var cents = Number(button.getAttribute('data-variant-price-cents') || 0);
      var compareCents = Number(button.getAttribute('data-variant-compare-cents') || 0);
      var hasCompare = compareCents > cents;
      var available = button.getAttribute('data-variant-available') === 'true';
      var qtyInput = section.querySelector('[data-bc-quantity]');
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10));
      var currency = section.getAttribute('data-currency');
      var addLabel = section.getAttribute('data-add-label') || 'Add to cart';
      var soldOutLabel = section.getAttribute('data-sold-out-label') || 'Sold out';
      var saleBadgePrefix = section.getAttribute('data-sale-badge-prefix') || 'Save';
      var saleBadgeText = formatSaleBadge(saleBadgePrefix, cents, compareCents);

      section.querySelectorAll('[data-bc-variant-button]').forEach(function(other) {
        var selected = other === button;
        other.classList.toggle('is-selected', selected);
        other.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      section.querySelectorAll('[data-bc-variant-input]').forEach(function(input) {
        input.value = id;
      });
      section.querySelectorAll('[data-bc-selected-price]').forEach(function(node) {
        node.textContent = formatMoney(cents, currency);
      });
      section.querySelectorAll('[data-bc-selected-total]').forEach(function(node) {
        node.textContent = formatMoney(cents * quantity, currency);
      });
      section.querySelectorAll('[data-bc-selected-compare]').forEach(function(node) {
        node.textContent = formatMoney(compareCents, currency);
        node.toggleAttribute('hidden', !hasCompare);
      });
      section.querySelectorAll('[data-bc-sticky-compare]').forEach(function(node) {
        node.textContent = formatMoney(compareCents * quantity, currency);
        node.toggleAttribute('hidden', !hasCompare);
      });
      section.querySelectorAll('[data-bc-sale-badge]').forEach(function(node) {
        node.textContent = saleBadgeText;
        node.toggleAttribute('hidden', !hasCompare);
      });
      section.querySelectorAll('[data-bc-selected-title]').forEach(function(node) {
        node.textContent = title;
      });
      section.querySelectorAll('[data-bc-sticky-price]').forEach(function(node) {
        node.textContent = formatMoney(cents * quantity, currency);
      });
      section.querySelectorAll('[data-bc-submit]').forEach(function(submit) {
        submit.disabled = !available;
      });
      section.querySelectorAll('[data-bc-submit-label]').forEach(function(label) {
        label.textContent = available ? addLabel : soldOutLabel;
      });
      section.setAttribute('data-selected-cents', String(cents));
      syncGroupedPicker(section, button);
      document.dispatchEvent(new CustomEvent('bc-product:variant-change', {
        bubbles: true,
        detail: {
          sectionId: section.getAttribute('data-bc-product-system') || '',
          variantId: id,
          title: title,
          groupKey: button.getAttribute('data-variant-group-key') || '',
          plug: button.getAttribute('data-variant-plug') || '',
          priceCents: cents,
          compareCents: compareCents,
          available: available
        }
      }));
    }

    function updateQuantity(section, value) {
      var qty = Math.max(1, parseInt(value || '1', 10));
      section.querySelectorAll('[data-bc-quantity]').forEach(function(input) {
        input.value = qty;
      });
      section.querySelectorAll('[data-bc-qty-input]').forEach(function(input) {
        input.value = qty;
      });
      var selected = section.querySelector('[data-bc-variant-button].is-selected') || section.querySelector('[data-bc-variant-button]');
      if (selected) updateVariant(section, selected);
    }

    function updateSticky(section) {
      var sticky = section.querySelector('[data-bc-sticky]');
      var mainCta = section.querySelector('[data-bc-main-cta]');
      if (!sticky || !mainCta) {
        document.body.classList.remove('bc-product-sticky-visible');
        return;
      }
      var rect = mainCta.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;
      var bundle = document.querySelector('[data-bc-product-bundle]');
      if (shouldShow && bundle && window.matchMedia('(max-width: 749px)').matches) {
        var bundleRect = bundle.getBoundingClientRect();
        if (bundleRect.top < window.innerHeight && bundleRect.bottom > 0) {
          shouldShow = false;
        }
      }
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('bc-product-sticky-visible', shouldShow);
    }

    function parseReviewNumber(value) {
      var match = String(value || '').replace(',', '.').match(/[0-9]+(?:\.[0-9]+)?/);
      return match ? Number(match[0]) : 0;
    }

    function parseReviewCount(value) {
      var match = String(value || '').match(/[0-9][0-9,.\s]*/);
      return match ? parseInt(match[0].replace(/[^\d]/g, ''), 10) || 0 : 0;
    }

    function extractWidgetReviewData(zone) {
      if (!zone) return null;
      var text = (zone.innerText || '').replace(/\u00a0/g, ' ');
      var compact = text.replace(/\s+/g, ' ').trim();
      if (!compact) return null;

      var ratingMatch = compact.match(/\b([1-5](?:[\.,]\d)?)\s*out of\s*5\b/i) || compact.match(/\b([1-5](?:[\.,]\d)?)\b(?=\s*(?:Based|Reviews?|review|Customer))/i) || compact.match(/\b([1-5][\.,]\d)\b/);
      var countMatch = compact.match(/Based on\s+([0-9][0-9,.\s]*)\s+Reviews?/i) || compact.match(/([0-9][0-9,.\s]*)\s+Reviews?/i);
      var rating = ratingMatch ? parseReviewNumber(ratingMatch[1]) : 0;
      var count = countMatch ? parseReviewCount(countMatch[1]) : 0;
      var distribution = {};

      [5, 4, 3, 2, 1].forEach(function(star) {
        var rowMatch = compact.match(new RegExp('(?:^|\\s)' + star + '\\s*(?:★|star)?\\s*\\(?\\s*([0-9]+)\\s*\\)', 'i'));
        distribution[String(star)] = rowMatch ? parseReviewCount(rowMatch[1]) : 0;
      });

      var distributionTotal = Object.keys(distribution).reduce(function(total, star) {
        return total + distribution[star];
      }, 0);

      if (!rating || !count) return null;
      return {
        rating: rating,
        count: count,
        distribution: distribution,
        distributionTotal: distributionTotal
      };
    }

    function applyWidgetReviewData(section, data) {
      if (!data || !data.rating || !data.count) return false;

      var heroRating = section.querySelector('[data-bc-hero-rating]');
      var heroRatingValue = section.querySelector('[data-bc-hero-rating-value]');
      var heroRatingCount = section.querySelector('[data-bc-hero-rating-count]');
      var wrapper = section.querySelector('[data-bc-review-wrapper]');
      var score = section.querySelector('[data-bc-review-score]');
      var empty = section.querySelector('[data-bc-review-empty]');
      var rating = section.querySelector('[data-bc-review-rating]');
      var count = section.querySelector('[data-bc-review-count]');
      var distribution = section.querySelector('[data-bc-review-distribution]');
      var detail = section.querySelector('[data-bc-review-detail]');
      var customersSay = section.querySelector('[data-bc-customers-say]');
      var divider = section.querySelector('[data-bc-review-divider]');
      var formattedRating = data.rating.toFixed(1).replace(/\.0$/, '');

      if (heroRating) {
        heroRating.hidden = false;
        heroRating.setAttribute('aria-label', 'Rated ' + formattedRating + ' out of 5 based on ' + data.count + ' reviews');
      }
      if (heroRatingValue) heroRatingValue.textContent = formattedRating;
      if (heroRatingCount) heroRatingCount.textContent = 'Based on ' + data.count + ' ' + (data.count === 1 ? 'Review' : 'Reviews');

      if (wrapper) {
        wrapper.classList.remove('bc-product-system__review-wrapper--empty');
        wrapper.classList.add('bc-product-system__review-wrapper--has-data');
      }
      if (score) score.hidden = false;
      if (empty) empty.hidden = true;
      if (rating) rating.textContent = formattedRating;
      if (count) count.textContent = 'Based on ' + data.count + ' ' + (data.count === 1 ? 'review' : 'reviews');
      if (customersSay) customersSay.hidden = false;
      if (divider) divider.hidden = false;

      if (distribution && data.distributionTotal > 0) {
        distribution.hidden = false;
        if (detail) detail.hidden = true;
        distribution.querySelectorAll('[data-bc-review-row]').forEach(function(row) {
          var star = row.getAttribute('data-star');
          var rowCount = data.distribution[star] || 0;
          var pct = data.distributionTotal > 0 ? rowCount * 100 / data.distributionTotal : 0;
          var bar = row.querySelector('[data-bc-review-bar]');
          var number = row.querySelector('[data-bc-review-row-count]');
          if (bar) bar.style.width = pct + '%';
          if (number) number.textContent = String(rowCount);
        });
      }

      return true;
    }

    function hideInjectedHeroReview(section) {
      section.querySelectorAll('.zegsu-product-title-review-section').forEach(function(node) {
        var host = node.parentElement;
        if (host && host.parentElement && host.parentElement.classList.contains('bc-product-system__info')) {
          host.hidden = true;
        } else {
          node.hidden = true;
        }
      });
    }

    function syncReviewLoadMore(list, button) {
      if (!list || !button) return;
      var hiddenCards = list.querySelectorAll('[data-bc-review-card][hidden]');
      button.hidden = hiddenCards.length === 0;
    }

    function escapeReviewText(value) {
      return String(value || '').replace(/[&<>"']/g, function(char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    function stripReviewHtml(value) {
      var div = document.createElement('div');
      div.innerHTML = value || '';
      return div.textContent || div.innerText || '';
    }

    function formatReviewDate(value) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        }).format(date);
      } catch (error) {
        return date.toLocaleDateString();
      }
    }

    function getReviewImage(review) {
      if (!review || !Array.isArray(review.pictures_urls) || !review.pictures_urls.length) return '';
      var picture = review.pictures_urls[0] || {};
      return picture.compact || picture.small || picture.original || picture.huge || '';
    }

    function renderJudgeMeReviewCard(review) {
      var rating = parseInt(review && review.rating ? review.rating : 0, 10);
      var name = review && review.reviewer_name ? review.reviewer_name : 'Customer';
      var initials = review && review.reviewer_initial ? review.reviewer_initial : name.slice(0, 2).toUpperCase();
      var body = review && review.body ? review.body : stripReviewHtml(review && review.body_html ? review.body_html : '');
      var title = review && review.title ? review.title : '';
      var image = getReviewImage(review);
      var date = formatReviewDate(review && review.created_at ? review.created_at : '');
      var stars = '';

      for (var i = 1; i <= 5; i += 1) {
        stars += '<i class="' + (i <= rating ? 'is-filled' : '') + '">★</i>';
      }

      return [
        '<article class="bc-product-system__review-card bc-product-system__judgeme-card" data-bc-review-card data-bc-judgeme-review="' + escapeReviewText(review && review.uuid ? review.uuid : '') + '">',
          '<div class="bc-product-system__review-card-meta">',
            '<span class="bc-product-system__review-avatar">' + escapeReviewText(initials) + '</span>',
            '<div>',
              '<div class="bc-product-system__review-card-name"><strong>' + escapeReviewText(name) + '</strong></div>',
              '<div class="bc-product-system__review-card-rating">',
                '<span aria-label="' + rating + ' out of 5 stars">' + stars + '</span>',
                date ? '<small>' + escapeReviewText(date) + '</small>' : '',
              '</div>',
            '</div>',
          '</div>',
          title ? '<h4>' + escapeReviewText(title) + '</h4>' : '',
          body ? '<p>' + escapeReviewText(body) + '</p>' : '',
          image ? '<figure><img src="' + escapeReviewText(image) + '" alt="Customer photo" loading="lazy" width="160" height="160"></figure>' : '',
        '</article>'
      ].join('');
    }

    function buildJudgeMeReviewsUrl(feed, nextPage) {
      var host = window.jdgm && window.jdgm.CDN_API_HOST ? window.jdgm.CDN_API_HOST : 'https://cdn.judge.me/';
      if (host.slice(-1) !== '/') host += '/';
      var params = new URLSearchParams({
        product_id: feed.getAttribute('data-bc-judgeme-product-id') || '',
        page: String(nextPage),
        shop_domain: feed.getAttribute('data-bc-judgeme-shop-domain') || '',
        platform: feed.getAttribute('data-bc-judgeme-platform') || 'shopify'
      });
      var sortKey = feed.getAttribute('data-bc-judgeme-sort-key') || 'created_at';
      var updatedAt = feed.getAttribute('data-bc-judgeme-updated-at') || '';
      if (sortKey) params.set('sort_by', sortKey);
      if (sortKey === 'created_at') params.set('sort_dir', 'desc');
      if (updatedAt) params.set('ts', updatedAt);
      return host + 'reviews/reviews_for_widget?' + params.toString();
    }

    function bindJudgeMeRemoteReviews(feed, button) {
      if (!feed || !button) return;
      var list = feed.querySelector('[data-bc-review-list]');
      if (!list) return;

      function syncButton() {
        var currentPage = parseInt(feed.getAttribute('data-bc-judgeme-page') || '1', 10);
        var totalPages = parseInt(feed.getAttribute('data-bc-judgeme-total-pages') || '1', 10);
        button.hidden = !totalPages || currentPage >= totalPages;
      }

      syncButton();

      button.addEventListener('click', function() {
        var currentPage = parseInt(feed.getAttribute('data-bc-judgeme-page') || '1', 10);
        var totalPages = parseInt(feed.getAttribute('data-bc-judgeme-total-pages') || '1', 10);
        var nextPage = currentPage + 1;
        var originalHtml = button.innerHTML;

        if (!totalPages || nextPage > totalPages) {
          syncButton();
          return;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Loading reviews...';

        fetch(buildJudgeMeReviewsUrl(feed, nextPage), {
          headers: { Accept: 'application/json' }
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Review request failed');
            return response.json();
          })
          .then(function(data) {
            var reviews = Array.isArray(data.reviews) ? data.reviews : [];
            if (reviews.length) {
              list.insertAdjacentHTML('beforeend', reviews.map(renderJudgeMeReviewCard).join(''));
            }
            if (data.pagination) {
              feed.setAttribute('data-bc-judgeme-page', String(data.pagination.current_page || nextPage));
              feed.setAttribute('data-bc-judgeme-total-pages', String(data.pagination.total_pages || totalPages));
            } else {
              feed.setAttribute('data-bc-judgeme-page', String(nextPage));
            }
          })
          .catch(function() {
            feed.setAttribute('data-bc-judgeme-load-error', 'true');
          })
          .finally(function() {
            button.innerHTML = originalHtml;
            button.disabled = false;
            button.removeAttribute('aria-busy');
            syncButton();
          });
      });
    }

    function bindReviewLoadMore(section) {
      section.querySelectorAll('[data-bc-review-load-more]').forEach(function(button) {
        if (button.getAttribute('data-bc-review-load-more-ready') === 'true') return;
        button.setAttribute('data-bc-review-load-more-ready', 'true');

        var judgeMeFeed = button.closest('[data-bc-judgeme-feed]');
        if (judgeMeFeed && button.hasAttribute('data-bc-judgeme-load-more')) {
          bindJudgeMeRemoteReviews(judgeMeFeed, button);
          return;
        }

        var scope = button.closest('.bc-product-system__curated-reviews') || button.closest('.bc-product-system__judgeme-feed') || section;
        var list = scope.querySelector('[data-bc-review-list]');
        syncReviewLoadMore(list, button);

        button.addEventListener('click', function() {
          if (!list) return;
          var batch = parseInt(list.getAttribute('data-bc-review-batch') || '5', 10);
          if (!batch || batch < 1) batch = 5;
          Array.prototype.slice.call(list.querySelectorAll('[data-bc-review-card][hidden]'), 0, batch).forEach(function(card) {
            card.hidden = false;
          });
          syncReviewLoadMore(list, button);
        });
      });
    }

    function hydrateReviewWrapper(section) {
      var wrapper = section.querySelector('[data-bc-review-wrapper]');
      var zone = section.querySelector('.bc-product-system__judge-zone');
      hideInjectedHeroReview(section);
      if (!wrapper || !zone) return;

      var attempts = 0;
      var maxAttempts = 30;

      function tryHydrate() {
        attempts += 1;
        if (applyWidgetReviewData(section, extractWidgetReviewData(zone))) return true;
        if (attempts < maxAttempts) window.setTimeout(tryHydrate, 300);
        return false;
      }

      tryHydrate();

      if (window.MutationObserver) {
        var observer = new MutationObserver(function() {
          hideInjectedHeroReview(section);
          if (applyWidgetReviewData(section, extractWidgetReviewData(zone))) observer.disconnect();
        });
        observer.observe(section, { childList: true, subtree: true, characterData: true });
      }
    }

    function showFormError(form, message) {
      var error = form.querySelector('.bc-form-error');
      if (!error) return;
      error.textContent = message || 'Something went wrong. Please try again.';
      error.hidden = false;
      window.setTimeout(function() {
        error.hidden = true;
      }, 6000);
    }

    function dispatchCartUpdate(cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || null,
          sourceId: 'bc-product-universal',
          data: {
            itemCount: cart ? cart.item_count : 0,
            source: 'bc-product-universal'
          }
        }
      }));
      document.dispatchEvent(new CustomEvent('bc-cart:open', {
        bubbles: true,
        detail: { cart: cart || null }
      }));
    }

    function setAdded(button) {
      if (!button) return;
      button.setAttribute('data-added', 'true');
      window.setTimeout(function() {
        button.removeAttribute('data-added');
      }, 1400);
    }

    function bindProductForms(section) {
      section.querySelectorAll('.bc-add-form').forEach(function(form) {
        if (form.getAttribute('data-bc-form-ready') === 'true') return;
        form.setAttribute('data-bc-form-ready', 'true');

        form.addEventListener('submit', function(event) {
          if (event.defaultPrevented || typeof window.fetch !== 'function') return;

          event.preventDefault();

          var button = form.querySelector('[type="submit"]');
          if (button && button.disabled) return;
          if (button) button.disabled = true;

          var routes = (window.Theme && window.Theme.routes) || {};
          var addUrl = routes.cart_add_url || '/cart/add.js';

          fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          })
            .then(function(response) {
              return response.json();
            })
            .then(function(result) {
              if (result.status) {
                showFormError(form, result.description || result.message);
                return null;
              }

              return fetch('/cart.js', {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
              }).then(function(response) {
                return response.json();
              });
            })
            .then(function(cart) {
              if (!cart) return;
              dispatchCartUpdate(cart);
              setAdded(button);
            })
            .catch(function() {
              showFormError(form, 'Something went wrong. Please try again.');
            })
            .finally(function() {
              if (button) button.disabled = false;
            });
        });
      });
    }

    function initSection(section) {
      if (section.getAttribute('data-bc-product-system-ready') === 'true') return;
      section.setAttribute('data-bc-product-system-ready', 'true');

      setGallery(section, 0);

      section.querySelectorAll('[data-bc-gallery-thumb]').forEach(function(button) {
        button.addEventListener('click', function() {
          setGallery(section, Number(button.getAttribute('data-bc-gallery-thumb') || 0));
        });
      });

      var prev = section.querySelector('[data-bc-gallery-prev]');
      var next = section.querySelector('[data-bc-gallery-next]');
      if (prev) {
        prev.addEventListener('click', function() {
          setGallery(section, Number(section.getAttribute('data-active-gallery') || 0) - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          setGallery(section, Number(section.getAttribute('data-active-gallery') || 0) + 1);
        });
      }

      section.querySelectorAll('[data-bc-variant-button]').forEach(function(button) {
        button.addEventListener('click', function() {
          updateVariant(section, button);
        });
      });

      section.querySelectorAll('[data-bc-group-button]').forEach(function(button) {
        button.addEventListener('click', function() {
          var groupKey = button.getAttribute('data-group-key');
          var plug = section.getAttribute('data-selected-plug') || button.getAttribute('data-group-default-plug') || '';
          if (button.getAttribute('data-group-has-plug') !== 'true') plug = '';
          var variant = findGroupedVariant(section, groupKey, plug);
          if (variant) updateVariant(section, variant);
        });
      });

      section.querySelectorAll('[data-bc-plug-button]').forEach(function(button) {
        button.addEventListener('click', function() {
          var groupKey = section.getAttribute('data-selected-group');
          var plug = button.getAttribute('data-plug');
          var variant = findGroupedVariant(section, groupKey, plug);
          if (variant) updateVariant(section, variant);
        });
      });

      section.querySelectorAll('[data-bc-qty-minus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-quantity]');
          updateQuantity(section, Number(input && input.value ? input.value : 1) - 1);
        });
      });

      section.querySelectorAll('[data-bc-qty-plus]').forEach(function(button) {
        button.addEventListener('click', function() {
          var input = section.querySelector('[data-bc-quantity]');
          updateQuantity(section, Number(input && input.value ? input.value : 1) + 1);
        });
      });

      section.querySelectorAll('[data-bc-quantity]').forEach(function(input) {
        input.addEventListener('change', function() {
          updateQuantity(section, input.value);
        });
      });

      section.querySelectorAll('.bc-product-system__faq-item button').forEach(function(button) {
        button.addEventListener('click', function() {
          var item = button.closest('.bc-product-system__faq-item');
          var panel = document.getElementById(button.getAttribute('aria-controls'));
          var willOpen = button.getAttribute('aria-expanded') !== 'true';
          if (!item || !panel) return;
          button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          item.classList.toggle('is-open', willOpen);
          panel.toggleAttribute('hidden', !willOpen);
        });
      });

      var selected = section.querySelector('[data-bc-variant-button].is-selected') || section.querySelector('[data-bc-variant-button]');
      if (selected) updateVariant(section, selected);

      bindProductForms(section);
      hydrateReviewWrapper(section);
      bindReviewLoadMore(section);
      updateSticky(section);
      window.addEventListener('scroll', function() { updateSticky(section); }, { passive: true });
      window.addEventListener('resize', function() { updateSticky(section); });
    }

    function initAllSections() {
      document.querySelectorAll('[data-bc-product-system]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
      initAllSections();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  function blueysEscapeText(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function blueysBuildVariantCards() {
    document.querySelectorAll('[data-blueys-variant-card-data]').forEach(function (script) {
      var data;
      var escapeSelector = window.CSS && CSS.escape
        ? CSS.escape
        : function (value) {
            return String(value).replace(/["\\]/g, '\\$&');
          };

      try {
        data = JSON.parse(script.textContent);
      } catch (error) {
        return;
      }

      if (!data || !Array.isArray(data.variants)) return;

      var selector = 'variant-picker[data-section-id="' + escapeSelector(data.sectionId) + '"]';
      var picker = document.querySelector(selector);

      if (!picker) return;

      blueysWatchVariantPicker(picker);

      data.variants.forEach(function (variant) {
        var input = picker.querySelector('input[data-variant-id="' + escapeSelector(String(variant.id)) + '"]');
        if (!input) return;

        var label = input.closest('.variant-option__button-label');
        if (!label) return;

        label.dataset.blueysOptionEnhanced = 'true';
        label.classList.add('blueys-option-card-label');

        if (label.querySelector(':scope > .blueys-option-card')) return;

        var card = document.createElement('span');
        card.className = 'blueys-option-card';
        card.setAttribute('aria-hidden', 'true');

        var media = document.createElement('span');
        media.className = 'blueys-option-card__media';

        if (variant.image) {
          var image = document.createElement('img');
          image.src = variant.image;
          image.alt = '';
          image.loading = 'lazy';
          media.appendChild(image);
        }

        var content = document.createElement('span');
        content.className = 'blueys-option-card__content';

        var topline = document.createElement('span');
        topline.className = 'blueys-option-card__topline';

        var title = document.createElement('span');
        title.className = 'blueys-option-card__title';
        title.innerHTML = blueysEscapeText(variant.title);
        topline.appendChild(title);

        if (variant.badge) {
          var badge = document.createElement('span');
          badge.className = 'blueys-option-card__badge';
          badge.innerHTML = blueysEscapeText(variant.badge);
          topline.appendChild(badge);
        }

        var detail = document.createElement('span');
        detail.className = 'blueys-option-card__detail';
        detail.innerHTML = blueysEscapeText(variant.detail);

        var bottom = document.createElement('span');
        bottom.className = 'blueys-option-card__bottom';

        var note = document.createElement('span');
        note.className = 'blueys-option-card__note';
        note.innerHTML = blueysEscapeText(variant.available ? variant.note : 'Currently unavailable');

        var price = document.createElement('span');
        price.className = 'blueys-option-card__price';
        price.innerHTML = blueysEscapeText(variant.price);

        if (variant.compareAtPrice) {
          var compare = document.createElement('span');
          compare.className = 'blueys-option-card__compare';
          compare.innerHTML = blueysEscapeText(variant.compareAtPrice);
          price.appendChild(compare);
        }

        bottom.appendChild(note);
        bottom.appendChild(price);

        content.appendChild(topline);
        content.appendChild(detail);
        content.appendChild(bottom);
        card.appendChild(media);
        card.appendChild(content);

        if (Array.isArray(variant.bullets) && variant.bullets.length) {
          var bullets = document.createElement('ul');
          bullets.className = 'blueys-option-card__bullets';

          variant.bullets.slice(0, 3).forEach(function (bulletText) {
            if (!bulletText) return;

            var bullet = document.createElement('li');
            bullet.innerHTML = blueysEscapeText(bulletText);
            bullets.appendChild(bullet);
          });

          if (bullets.children.length) {
            card.appendChild(bullets);
          }
        }

        label.appendChild(card);
      });
    });
  }

  function blueysRefreshVariantCardsSoon() {
    window.requestAnimationFrame(blueysBuildVariantCards);
    window.setTimeout(blueysBuildVariantCards, 80);
    window.setTimeout(blueysBuildVariantCards, 300);
    blueysPlaceSubscriptionWidgetSoon();
  }

  function blueysWatchVariantPicker(picker) {
    if (picker.dataset.blueysOptionObserver === 'true') return;

    picker.dataset.blueysOptionObserver = 'true';

    var observer = new MutationObserver(function () {
      window.clearTimeout(picker.blueysOptionRefreshTimer);
      picker.blueysOptionRefreshTimer = window.setTimeout(blueysBuildVariantCards, 0);
    });

    observer.observe(picker, {
      childList: true,
      subtree: true,
    });

    picker.addEventListener('change', blueysRefreshVariantCardsSoon);
    picker.addEventListener('click', blueysRefreshVariantCardsSoon);
  }

  function blueysGetSubscriptionBlock() {
    var container = document.querySelector('.shopify_subscriptions_app_container');

    if (!container) return null;

    return container.closest('.shopify-app-block') || container;
  }

  function blueysSubscriptionHasActivePlan(block) {
    if (!block) return false;

    return Boolean(block.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)'));
  }

  function blueysPlaceSubscriptionWidget() {
    var block = blueysGetSubscriptionBlock();
    var aside = document.querySelector('.blueys-product-aside');

    if (!block || !aside) return;

    var productDetails = aside.querySelector('.product-details') || aside;
    var buyButtons = productDetails.querySelector('.buy-buttons-block') || productDetails.querySelector('product-form-component');

    if (!buyButtons || !buyButtons.parentElement) return;

    var slot = productDetails.querySelector('.blueys-subscription-slot');

    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'blueys-subscription-slot';
      slot.setAttribute('data-blueys-subscription-slot', 'true');
    }

    if (slot.parentElement !== buyButtons.parentElement || slot.nextElementSibling !== buyButtons) {
      buyButtons.parentElement.insertBefore(slot, buyButtons);
    }

    if (block.parentElement !== slot) {
      slot.appendChild(block);
    }

    block.classList.add('blueys-subscription-card');

    var hasActivePlan = blueysSubscriptionHasActivePlan(block);
    slot.hidden = !hasActivePlan;
    block.hidden = !hasActivePlan;
  }

  function blueysPlaceSubscriptionWidgetSoon() {
    if (window.blueysSubscriptionPlacementTimer) {
      window.clearTimeout(window.blueysSubscriptionPlacementTimer);
    }

    window.requestAnimationFrame(blueysPlaceSubscriptionWidget);
    window.blueysSubscriptionPlacementTimer = window.setTimeout(blueysPlaceSubscriptionWidget, 120);
    window.setTimeout(blueysPlaceSubscriptionWidget, 420);
  }

  function blueysWatchSubscriptionPlacement() {
    if (document.documentElement.dataset.blueysSubscriptionPlacementObserver === 'true') return;

    document.documentElement.dataset.blueysSubscriptionPlacementObserver = 'true';

    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (mutation) {
        if (mutation.type === 'childList') return mutation.addedNodes.length || mutation.removedNodes.length;

        if (mutation.type === 'attributes') {
          return mutation.target.classList && (
            mutation.target.classList.contains('shopify_subscriptions_app_block') ||
            mutation.target.closest('.shopify_subscriptions_app_container')
          );
        }

        return false;
      });

      if (shouldRefresh) {
        blueysPlaceSubscriptionWidgetSoon();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'data-variant-id'],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      blueysBuildVariantCards();
      blueysPlaceSubscriptionWidgetSoon();
      blueysWatchSubscriptionPlacement();
    });
  } else {
    blueysBuildVariantCards();
    blueysPlaceSubscriptionWidgetSoon();
    blueysWatchSubscriptionPlacement();
  }

  document.addEventListener('shopify:section:load', function () {
    blueysBuildVariantCards();
    blueysPlaceSubscriptionWidgetSoon();
    blueysWatchSubscriptionPlacement();
  });
  document.addEventListener('variant:change', blueysRefreshVariantCardsSoon);
  document.addEventListener('product:variant-change', blueysRefreshVariantCardsSoon);

  } catch(e) { console.error(e); }
})();
})();
